<template>
  <div>
    <div class="mt-5 sign-print" v-if="last" style="margin-top: 15px">
      <table style="width: 100%">
        <tbody>
          <tr>
            <td>
              <div class="resume-mt-1">
                <div class="mt-1">
                  <input
                    :class="
                      term.changeDate
                        ? 'empty-input-hg empty-input-editable'
                        : 'empty-input-hg'
                    "
                    v-model="paymentLocal"
                  />
                  ,
                  <input
                    :class="
                      term.changeDate
                        ? 'empty-input-small empty-input-editable'
                        : 'empty-input-small'
                    "
                    v-model="term.day"
                  />
                  de
                  <input
                    :class="
                      term.changeDate
                        ? 'empty-input empty-input-editable'
                        : 'empty-input'
                    "
                    v-model="term.month"
                  />
                  de
                  <input
                    :class="
                      term.changeDate
                        ? 'empty-input empty-input-editable'
                        : 'empty-input'
                    "
                    v-model="term.year"
                  />.
                </div>
                <div>Local e data</div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="sign sign-print" v-if="isIlliterate">
      <table style="width: 100%">
        <tbody>
          <tr>
            <td style="width: 40%">
              <input class="signature" style="width: 100%" />
            </td>
            <td style="width: 10%" />
            <td />
            <td style="width: 45%">
              <input class="signature" style="width: 100%" />
            </td>
          </tr>
          <tr>
            <td>
              <span class="without-underline label-divTableCell"
                >TESTEMUNHA 1</span
              >
            </td>
            <td></td>
            <td>
              <span class="without-underline label-divTableCell">RG</span>
            </td>
            <td style="width: 50px" />
            <td />
          </tr>

          <tr>
            <td>&nbsp;</td>
          </tr>

          <tr v-if="last">
            <td style="width: 40%">
              <input class="signature" style="width: 100%" />
            </td>
            <td style="width: 10%" />
            <td />
            <td style="width: 45%">
              <input class="signature" style="width: 100%" />
            </td>
          </tr>
          <tr v-if="last">
            <td>
              <span class="without-underline">Testemunha 2</span>
            </td>
            <td style="width: 50px" />
            <td />
            <td>
              <span class="without-underline">RG</span>
            </td>
          </tr>
          <!-- Tempo de fidelização pra planos corporativos -->
          <tr v-if="getCorporativoFidelizacao">
            <td>&nbsp;</td>
          </tr>
          <tr v-if="getCorporativoFidelizacao">
            <td style="width: 45%">
              <span class="without-underline"
                >Tempo de fidelização contratada</span
              >&nbsp;&nbsp;&nbsp;
              <span class="without-underline">
                (
                <span
                  class="without-underline"
                  v-if="tempoFidelizacaoCorporativo == '12'"
                  >X</span
                >) 12 meses (
                <span
                  class="without-underline"
                  v-if="tempoFidelizacaoCorporativo == '24'"
                  >X</span
                >) 24 Meses
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="sign sign-print" v-if="isIlliterate">
      <table style="width: 100%">
        <tbody>
          <tr>
            <td style="width: 40%">
              <input class="signature" style="width: 100%" />
            </td>
            <td style="width: 10%" />
            <td />
            <td style="width: 45%">
              <input class="signature" style="width: 100%" />
            </td>
          </tr>
          <tr>
            <td>
              <span class="without-underline label-divTableCell"
                >TESTEMUNHA 2</span
              >
            </td>
            <td></td>
            <td>
              <span class="without-underline label-divTableCell">RG</span>
            </td>
            <td style="width: 50px" />
            <td />
          </tr>

          <tr>
            <td>&nbsp;</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      paymentLocal: "",
    };
  },
  props: {
    last: {
      type: Boolean,
      default: false,
    },
    pageNumber: {
      type: Number,
      default: 1,
    },
    pessoa: {
      type: String,
      required: true,
    },
    illiterate: {
      type: Boolean,
    },
    hasProcuration: {
      type: Boolean,
      required: true,
    },
    representative: {
      type: Boolean,
      required: true,
    },
    corporativoFidelizacao: {
      type: Boolean,
      required: false,
      default: false,
    },
    tempoFidelizacaoCorporativo: {
      type: String,
      required: false,
      default: "",
    },
  },
  computed: {
    ...mapGetters({
      term: "term/term",
    }),
    isTitular() {
      return (
        !this.isRepresentative && !this.isProcuration && !this.isIlliterate
      );
    },
    isRepresentative() {
      return (
        this.pessoa === "juridica" && !this.illiterate && this.representative
      );
    },
    isProcuration() {
      return (
        this.pessoa === "fisica" && !this.illiterate && this.hasProcuration
      );
    },
    isIlliterate() {
      return this.illiterate;
    },
    getCorporativoFidelizacao() {
      return this.corporativoFidelizacao;
    },
  },
  mounted() {
    if (window.localStorage.getItem("paymentLocal")) {
      this.paymentLocal = window.localStorage.getItem("paymentLocal");
    }
  },
  methods: {
    getDay() {
      var d = new Date();
      return "  " + d.getDate();
    },
    getMonth() {
      var d = new Date();
      return "  " + d.toLocaleString("default", { month: "long" });
    },
    getYear() {
      var d = new Date();
      return "  " + d.getFullYear();
    },
  },
};
</script>

<style lang="scss" scoped>
tr {
  width: 1000px;
}
.testemunha2 {
  width: 40%;
  margin-left: 22.5em;
}
.without-underline {
  text-decoration: none;
}
.sign {
  width: 100%;
}

.sign-print {
  border-bottom: 1px dashed;
  padding: 0 20px 10px 20px;
}

.sign-print-text {
  padding: 10px 20px 10px 0px;
}
</style>
